var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    dataname: "Grupo 59",
    transform: "translate(-585.884 -864.53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_81",
    dataname: "Rect\\xE1ngulo 81",
    width: 72,
    height: 72,
    rx: 36,
    transform: "translate(585.884 864.53)",
    fill: "#2f9980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    dataname: "Trazado 76",
    d: "M658.9,914.463l-3.393,3.4.028.029-19.834,19.849L623.629,925.65l3.654-3.657,8.423,8.429,16.179-16.191.027.026,3.394-3.395Z",
    transform: "translate(-19.383 -23.769)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckCircle);
export default __webpack_public_path__ + "static/media/GreenCheckCircle.c48c9fc9170a84051eeb325a45053e1b.svg";
export { ForwardRef as ReactComponent };